import Table from "@tiptap/extension-table";
import { getHTMLFromFragment } from "@tiptap/core";
import { Fragment, Node as ProseMirrorNode } from "@tiptap/pm/model";

interface MarkdownSerializerState {
  write(content: string): void;
  closeBlock(node: ProseMirrorNode): void;
}

export const CustomTable = Table.extend({
  addStorage() {
    return {
      ...this.parent?.(),
      markdown: {
        serialize(state: MarkdownSerializerState, node: ProseMirrorNode) {
          const schema = node.type.schema;
          const html = getHTMLFromFragment(Fragment.from(node), schema);
          state.write(formatBlock(html));
          state.closeBlock(node);
        },
        parse: {
          // handled by markdown-it
        }
      }
    };
  }
});

function formatBlock(html: string): string {
  const parser = new DOMParser();
  const doc = parser.parseFromString(html, "text/html");
  const element = doc.body.firstElementChild as HTMLElement;

  if (element) {
    element.innerHTML = element.innerHTML.trim() ? `\n${element.innerHTML}\n` : `\n`;
    return element.outerHTML;
  }

  return html;
}
